import { SparklesIcon } from "../../icons.js";
import { relativeTime } from "../../../lib/time.js";
import type { WidgetProps } from "../types.js";

export function AnalyzeWidget({ events, onNavigate }: WidgetProps) {
  // Report events are saved analysis runs (eventType "report").
  const latestReport = events.find((e) => e.eventType === "report");

  return (
    <section className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
      <div className="mb-2 flex items-center gap-2">
        <SparklesIcon size={16} className="text-(--accent)" />
        <h2 className="font-semibold text-gray-900 dark:text-gray-100">Analyze</h2>
      </div>
      {latestReport ? (
        <p className="mb-3 text-sm text-gray-500 dark:text-gray-400">
          Last analysis {relativeTime(latestReport.occurredAt)}
        </p>
      ) : (
        <p className="mb-3 text-sm text-gray-400 dark:text-gray-500">
          AI-powered pattern analysis over your logged data
        </p>
      )}
      <button
        onClick={() => onNavigate("analyze")}
        className="flex items-center gap-2 rounded-lg bg-(--accent) px-3 py-1.5 text-sm font-medium text-(--accent-contrast) hover:bg-(--accent-hover)"
      >
        <SparklesIcon size={14} />
        Run analysis
      </button>
    </section>
  );
}
